import clientAPI from "@/api/ClientAPIMixin.js";
import QEvent from '@/views/planning/QEvent.js';
import {
  DateHelper,
  DomHelper,
  DragHelper,
} from "@bryntum/schedulerpro";


export default {
  name: 'SchedulerDragMixin',
  mixins: [clientAPI],

  data() {
    return {
      dragHelper: null,
    };
  },

  mounted() { },

  methods: {
    async initializeDrag() {
      if (!this.dragHelper) {
        //console.log('initializing drag');
        const callCreateProxy = (obj) => this.createProxy(obj);
        const callOnTaskDragStart = (obj) => this.onTaskDragStart(obj);
        const callOnTaskDrag = (obj) => this.onTaskDrag(obj);
        const callOnTaskDrop = async (obj) => this.onTaskDrop(obj);
        const sm = this.scheduler.scrollManager;
        this.dragHelper = new DragHelper(
          {
            cloneTarget: true,
            autoSizeClonedTarget : false,
            dropTargetSelector: '.b-timeline-subgrid', // Only allow drops on the schedule area
            targetSelector: '.br-draggable',
            dropTargetCls: 'test123',
            invalidCls: 'dragproxyOverInvalidTarget',
            scrollManager: sm,
            createProxy: callCreateProxy,
            listeners: {
              dragstart: callOnTaskDragStart,
              drag: callOnTaskDrag,
              drop: callOnTaskDrop,
              thisObj: this
            },
          },
        );
      }
    },

    createProxy(element) {
      const oneHourInMs = 1000 * 60 * 60;
      const numHours = (this.isDayMode ? (element.dataset.estimatedtime ?? 2) : 24);
      var task = {
        id: element.dataset.jobid,
        name: element.dataset.subject,
        durationMS: oneHourInMs * numHours,
      };

      const
        proxy = document.createElement('div'),
        durationInPx = this.scheduler.timeAxisViewModel.getDistanceForDuration(task.durationMS);

      // Fake an event bar
      proxy.classList.add('b-sch-event', 'dragproxy', `b-sch-${this.scheduler.mode}`);
      proxy.innerHTML = `<div>${task.name}</div>`;
      const height = `${this.scheduler.rowHeight - (2 * this.scheduler.resourceMargin)}px`;
      proxy.style.height = height;
      proxy.style.maxHeight = height;
      proxy.style.minHeight = height;
      const width = `${durationInPx}px`;
      proxy.style.width = width;
      proxy.style.minWidth = width;
      proxy.style.maxWidth = width;

      return proxy;
    },

    onTaskDragStart({ context }) {
      var element = context.grabbed;
      var task = new QEvent();
      task.name = element.dataset.subject;
      task.jobId = element.dataset.jobid;
      task.durationNum = element.dataset.estimatedtime;
      task.duration = element.dataset.estimatedtime + 'h';
      task.durationUnit = 'hour';
      context.task = task;   // save a reference to the task so we can access it later
    },

    onTaskDrag({ context }) {
      const
        task = context.task,
        target = context.target,
        coordinate = DomHelper[`getTranslate${this.scheduler.mode === 'horizontal' ? 'X' : 'Y'}`](context.element),  // Coordinates required when used in vertical mode, since it does not use actual columns
        startDate = this.scheduler.getDateFromCoordinate(coordinate, 'round', false),
        endDate = startDate && DateHelper.add(startDate, task.duration, task.durationUnit),
        resource = target && this.scheduler.resolveResourceRecord(target);

      document.querySelectorAll(".dragHoverRow").forEach(el => { el.classList.remove('dragHoverRow') })  // Removing prevoiusly targeted outliend rows
      context.valid = Boolean(startDate && resource?.name);
      if (context.valid) {
        target?._domData?.rowElement?.classList.add('dragHoverRow'); //apply outline effect to target row

        context.resource = resource;    // Save reference to resource so we can use it in onTaskDrop
        task.startDate = startDate;
        task.endDate = endDate;
        context.coordinate = coordinate;
      }
      //var format = this.isDayMode ? 'HH:mm' : 'D. MMM - HH:mm';
    },

    async onTaskDrop({ context }) {
      const
        task = context.task,
        resource = context.resource;
      //console.log('onTaskDrop', Object.assign({}, context));
      // If drop was done in a valid location create the appointment
      if (context.valid) {
        if (!this.isDayMode) { //if not day mode show dialog
          this.openEventDialog({ eventRecord: task, resourceRecord: resource });
        }
        else {
           const dto = {
            Id: null,
            Subject: task.name,
            AppointmentDate: task.startDate,
            StartTime: task.startDate,
            EndTime: task.endDate,
            JobId: task.jobId,
            Participants: [{ Id: resource.id, Name: resource.name }]
          };
          await clientAPI.methods.createAppointment(dto)
            .then((response) => {
              this.addOrUpdateEventInStoreById(response.Id);
              this.$store.dispatch("plannerstore/RemoveUnplannedJobById", response.JobId);
            });
        }
      }
    },
  },

  computed: {
    plannerScope() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerScope");
    },
      
    isDayMode() {
      return this.plannerScope == 'QDay';
    },
  },

  watch: {},
}